// Core

// Chakra
import {
    Box,
    Flex,
    Button,
    Text,
    useDisclosure,
} from '@chakra-ui/react';


import {EditIcon, DeleteIcon} from 'components/Icons/Icons';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Attention from 'components/Modals/Attention.js';
import usePermissionStatusByKey from '../../../../../hooks/usePermissionStatusByKey';

const RoleRow = ({item, handleEditOpen, handleActiveChange, handleDelete}) => {

    const {isOpen, onOpen, onClose} = useDisclosure();
    const attentionModal = async () => {
        console.log('attentionModal');
        onOpen();
    };

    const isDeleteRole = usePermissionStatusByKey('DELETE:/admin/roles/:id');

    const isRole = usePermissionStatusByKey('GET:/admin/roles/:id');

    return (
        <Card key={item?.id} padding="24px">
            <CardBody>
                <Box width="100%">
                    <Text
                        variant="title-lg"
                        fontSize="24px"
                        lineHeight="26px"
                        maxW="100%"
                        overflow="hidden"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical'
                        }}
                    >
                        {item.name}
                    </Text>

                    {item?.id === 0 || item?.id === -1 ? (
                        <Button variant="secondary-md" disabled={true} w="100%" mt="20px">
                            Default Role (Locked)
                        </Button>
                    ) : (
                        <Flex justifyContent="space-between" w="100%" gap="8px" mt="20px">
                            {isDeleteRole && <Button
                                variant="secondary-md"
                                disabled={item?.name === 'Manager' || item?.name === 'Partner'}
                                w="50px"
                                onClick={attentionModal}
                                leftIcon={<DeleteIcon color="#DE3730" fontSize="22px" pl="4px" mr="-4px"/>}/>}
                            {isRole && <Button
                                variant="secondary-md"
                                w="100%"
                                onClick={() => handleEditOpen(item)}
                                leftIcon={<EditIcon color="white" fontSize="24px"/>}>
                                Change
                            </Button>
                            }
                        </Flex>
                    )}
                </Box>

                <Attention
                    variant="delete-role"
                    handle={() => handleDelete(item)}
                    isOpen={isOpen}
                    onOpen={onOpen}
                    onClose={onClose}/>
            </CardBody>
        </Card>
    );
};

export default RoleRow;